import { useProductSheet } from 'context/product-sheet';

// { id: '1', targetId: 'W', name: 'Woman', url: '/es_ES/mujer/zapatos/m/{sku}' },
// { id: '2', targetId: 'M', name: 'Men', url: '/es_ES/hombre/zapatos/m/{sku}' },
const targetOrder = {
  W: 1,
  M: 2,
};

type TargetLinksProps = {
  className?: string;
};
export function TargetLinks({ className }: TargetLinksProps) {
  const { productSheet } = useProductSheet();
  if (!productSheet?.targetLinks || productSheet?.targetLinks.length === 0) return null;
  return (
    <div className={className}>
      <ol className="mb-0 grid grid-cols-2 gap-px border border-[#DFDFDF] bg-[#DFDFDF] nnormal:gap-0 nnormal:border-dark nnormal:bg-clear">
        {productSheet?.targetLinks
          .sort((a, b) => targetOrder[a.targetId] - targetOrder[b.targetId])
          .map((link, i) => {
            return (
              <li key={`target-link-${link.targetId ?? i}`} className="block h-9 w-full">
                {link.targetId === productSheet?.realTarget ?
                  <span className="flex h-full w-full items-center justify-center text-xs capitalize text-copy nnormal:bg-neutral-inverted nnormal:text-inverted">
                    {link.name}
                  </span>
                : <a
                    className="flex h-full w-full items-center justify-center bg-clear text-xs capitalize text-[#919191] transition-colors nnormal:text-copy nnormal:hover:bg-faint camper:hover:bg-[#DFDFDF]"
                    href={link.url}
                  >
                    {link.name}
                  </a>
                }
              </li>
            );
          })}
      </ol>
    </div>
  );
}
